
const parsePhone = (phone: string) => {
  return phone.split('').filter(c => c >= '0' && c <= '9').join('')
}

export default parsePhone